export enum CardLinkTitle {
  CALENDAR = 'Календарь занятий',
  WEBINARS = 'Вебинары',
  LESSONS = 'Материалы',
  TESTS = 'Задания',
  EXAMINATION = 'Тесты',
  DEFAULT = 'Заголовок',
}



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/remotemenu/components/menucard/types.ts